import Global from '@/global'
import { hileiaHttp } from '@/utils/http'
import axios from 'axios'

const apis = {
  createConference: '/hiapiw/app/conference/create',
  queryConference: '/hiapigw/app/conference/query',
  queryConferenceList: '/hiapigw/app/conference/list/query',
  queryRecordDetail: '/hiapigw/admin/record/newRecordList',

  joinCoc: '/hiapigw/app/conference/join',
  cancelCoc: '/hiapigw/app/conference/cancel',
  startCoc: '/hiapigw/app/conference/start',
  stopCoc: '/hiapigw/app/conference/stop',
  confirmCocInvite: '/hiapigw/app/conference/invite/confirm',
  removeCocMember: '/hiapigw/app/conference/members/remove',
  addCocMember: '/hiapigw/app/conference/members/add',

  removeAttachFiles: '/hiapigw/app/conference/files/delete',
  queryAttachFiles: '/hiapigw/app/conference/files/query',
  updateAttachFiles: '/hiapigw/app/conference/files/update',
  addAttachFiles: '/hiapigw/app/conference/files/add'
}

/**
 * 创建协作
 */
export function createConference(data) {
  return axios.post(apis.createConference, data)
}

/**
 * 查询协作信息
 */
export function queryConference(conferenceId) {
  return hileiaHttp.get(apis.queryConference, {
    params: { conferenceId }
  })
}

/**
 * 协作列表
 */
export function queryConferenceList(data) {
  return hileiaHttp.post(apis.queryConferenceList, data || {}, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

/**
 * 通话记录详情
 */
export function queryRecordDetail(channelId) {
  return hileiaHttp.post(
    apis.queryRecordDetail,
    {},
    {
      params: { channelId },
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 取消会议
export function cancelCoc(conferenceId) {
  return hileiaHttp.post(apis.cancelCoc, { conferenceId })
}

// 开始会议
export function startCoc(conferenceId) {
  return hileiaHttp.post(apis.startCoc, { conferenceId })
}

// 结束会议
export function stopCoc(conferenceId) {
  return hileiaHttp.post(apis.stopCoc, { conferenceId })
}

// 确认会议邀请(同意)
export function confirmCocInvite(data) {
  return hileiaHttp.post(apis.confirmCocInvite, data)
}

// 删除成员
export function removeCocMember(data) {
  return hileiaHttp.post(apis.removeCocMember, data)
}

// 添加成员
export function addCocMember(data) {
  return hileiaHttp.post(apis.addCocMember, data)
}

// 加入协作
export function joinCoc(data) {
  return hileiaHttp.post(apis.joinCoc, data)
}

// 添加附件
export function addAttachFiles(data) {
  return hileiaHttp.post(apis.addAttachFiles, data)
}

// 查询附件
export function queryAttachFiles(conferenceId) {
  return hileiaHttp.post(apis.queryAttachFiles, { conferenceId })
}

// 更新附件
export function updateAttachFiles(data) {
  return hileiaHttp.post(apis.updateAttachFiles, data)
}

// 删除附件
export function removeAttachFiles(data) {
  return hileiaHttp.post(apis.removeAttachFiles, data)
}
